import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';
import { Upload } from './upload/upload';
import * as firebase from 'firebase';

export interface Company {
  active: number;
  createdAt: any;
  updatedAt: any;

  name: string;
  imageURL?: string;
  imageNAME?: string;
  location?: any;
  phoneOne: string;
  phoneTwo?: string;
  email: string;
  webPage: string;

  socialReason: string;
  RFC: string;
  fiscalRegimen: keyof CompanyData['fiscalRegimenSelect'];

  street: string;
  numExt: string;
  numInt?: string;
  colony: string;
  municipality: string;
  city: string;
  postCode: string;
  state: string;
  country: string;

  satPrivateKey: string;

  supAddress: string;
  supNotes: string;

  files: File[];
}

export interface File{
  id: string;
  name: string;
  url: string;
}

export interface CompanyId extends Company {
  id: string;
}

@Injectable()
export class CompanyService {

  companyId: string;

  companyCollection: AngularFirestoreCollection<Company>;
  companies: any;

  companyDocument: AngularFirestoreDocument<CompanyId>;
  company: Observable<CompanyId>;

  collection: string;

  // NOTE: Change this any for Company Interface
  company$: Observable<any>;
  companies$: Observable<any[]>;

  constructor(
    private afs: AngularFirestore,
    private afh: FirestoreService,
    private router: Router
  ) {
    this.collection = Globals.COMPANIES_COLLECTION;
    this.companyId = Globals.AGRO_VIVA_DOCUMENT_ID;
  }

  /**
  * Get company data
  * @return {Observable} The Company Object
  */
  getCompany() {
    console.log(this.collection + '/' + this.companyId)
    return this.afh.docWithIds$(this.collection + '/' + this.companyId);
  }

  /**
   * Update current company
   * @param {string} sid  - The id of the company
   * @param {Company} company - The data of the company
   */
  updateCompany(company: Company) {
    this.afh.update(`${this.collection}/${this.companyId}`, company);
    this.router.navigate(['/company']);
  }

  uploadImage(upload: Upload,company?: Company) {
    const storageRef = firebase.storage().ref();
    const uploadTask = storageRef.child(`${this.collection}/${this.companyId}/profilePicture/${upload.file.name}`).put(upload.file);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot: any) => {
      upload.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    }, (err) => {
      console.log('error en company.service');
    }, () => {
      upload.url = uploadTask.snapshot.downloadURL;
      upload.name = upload.file.name;
      if(company.imageNAME && company.imageNAME != upload.file.name){
        var imageToDeleteRef = storageRef.child(`${this.collection}/${this.companyId}/profilePicture/${company.imageNAME}`);
        imageToDeleteRef.delete();
      }
      this.updateCompanyPictureData(upload);
    });
  }

  updateCompanyPictureData(upload: Upload){
    const data = {
      imageURL: upload.url,
      imageNAME: upload.name
    };
    this.afh.update(`${this.collection}/${this.companyId}`, data);
  }

  uploadFile(upload: Upload, company: CompanyId, fileName: string) {
    let files = company.files || [];
    const fileId = `${this.makeFileId}_${files.length}_${new Date().getTime()}_${fileName}`;
    const storageRef = firebase.storage().ref();
    const uploadTask = storageRef.child(`${this.collection}/${this.companyId}/files/${fileId}`).put(upload.file);
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot: any) => {
      upload.progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    }, (err) => {
      console.log('error al subir');
    }, () => {
      files.push({
        id: fileId,
        name: fileName,
        url: uploadTask.snapshot.downloadURL
      });
      this.afh.update(`${this.collection}/${this.companyId}`, {files});
    });
  }
  deleteFile(company: CompanyId, index){
    const fileId = company.files[index].id;
    const storageRef = firebase.storage().ref();
    var imageToDeleteRef = storageRef.child(`${this.collection}/${this.companyId}/files/${fileId}`);
    imageToDeleteRef.delete();
    company.files.splice(index, 1);
    this.afh.update(`${this.collection}/${this.companyId}`, {files: company.files});
  }
  get makeFileId(){
      var text = "";
      var possibleL = "ABCDEFGHIJKLMNPQRSTUVWXYZabcdefghijklmnpqrstuvwxyz";
      for (var i = 0; i < 11; i++) text += possibleL.charAt(Math.floor(Math.random() * possibleL.length));
    return text;
  }

}

export class CompanyData{
  fiscalRegimenSelect = {
    'key0': {code: '601', name: 'General de Ley Personas Morales', get full(){ return `${this.code} - ${this.name}` }},
    'key1': {code: '603', name: 'Personas Morales con Fines no Lucrativos', get full(){ return `${this.code} - ${this.name}` }},
    'key2': {code: '605', name: 'Sueldos y Salarios e Ingresos Asimilados a Salarios', get full(){ return `${this.code} - ${this.name}` }},
    'key3': {code: '606', name: 'Arrendamiento', get full(){ return `${this.code} - ${this.name}` }},
    'key4': {code: '608', name: 'Demás ingresos', get full(){ return `${this.code} - ${this.name}` }},
    'key5': {code: '609', name: 'Consolidación', get full(){ return `${this.code} - ${this.name}` }},
    'key6': {code: '610', name: 'Residentes en el Extranjero sin Establecimiento Permanente en México', get full(){ return `${this.code} - ${this.name}` }},
    'key7': {code: '611', name: 'Ingresos por Dividendos (socios y accionistas)', get full(){ return `${this.code} - ${this.name}` }},
    'key8': {code: '612', name: 'Personas Físicas con Actividades Empresariales y Profesionales', get full(){ return `${this.code} - ${this.name}` }},
    'key9': {code: '614', name: 'Ingresos por intereses', get full(){ return `${this.code} - ${this.name}` }},
    'key10': {code: '616', name: 'Sin obligaciones fiscales', get full(){ return `${this.code} - ${this.name}` }},
    'key11': {code: '620', name: 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos', get full(){ return `${this.code} - ${this.name}` }},
    'key12': {code: '621', name: 'Incorporación Fiscal', get full(){ return `${this.code} - ${this.name}` }},
    'key13': {code: '622', name: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras', get full(){ return `${this.code} - ${this.name}` }},
    'key14': {code: '623', name: 'Opcional para Grupos de Sociedades', get full(){ return `${this.code} - ${this.name}` }},
    'key15': {code: '624', name: 'Coordinados', get full(){ return `${this.code} - ${this.name}` }},
    'key16': {code: '628', name: 'Hidrocarburos', get full(){ return `${this.code} - ${this.name}` }},
    'key17': {code: '607', name: 'Régimen de Enajenación o Adquisición de Bienes', get full(){ return `${this.code} - ${this.name}` }},
    'key18': {code: '629', name: 'De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales', get full(){ return `${this.code} - ${this.name}` }},
    'key19': {code: '630', name: 'Enajenación de acciones en bolsa de valores', get full(){ return `${this.code} - ${this.name}` }},
    'key20': {code: '615', name: 'Régimen de los ingresos por obtención de premios', get full(){ return `${this.code} - ${this.name}` }},
    'key21': {code: '625', name: 'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas', get full(){ return `${this.code} - ${this.name}` }},
    'key22': {code: '626', name: 'Régimen Simplificado de Confianza', get full(){ return `${this.code} - ${this.name}` }},
  };// as const;
}